import {load} from '@shopify/theme-sections'

/**
 * Global theme helpers.
 */
import './helpers/polyfill'
import './helpers/lazysizes'
import EventBus from './helpers/event-bus'
import CurrentCarCookie from './helpers/current-car-cookie'
import AjaxCart from './helpers/ajax-cart'
import Redirects from './helpers/redirects'
/**
 * Components.
 */
// import Select from './components/Select'
import Slick from './components/Slick'
// import Preload from './components/Preload'
import pageContext from 'salvo-lite/context'
import CollectionPanel from './components/CollectionPanel'
import Notification from './components/Notification'
import ChangeClass from './components/ChangeClass'
import Carousel from './components/Carousel'
import Masonry from './components/Masonry'
import Accordion from './components/Accordion'
import SearchBar from './components/SearchBar'
import Toggle from './components/Toggle'
import VehicleCarousel from './components/VehicleCarousel'
import SiteNav from './components/SiteNav'
import CountrySelector from './components/CountrySelector'
import Modal from './components/Modal'
import KlevuSearch from './components/KlevuSearch'
import ProductGallery from './components/ProductGallery'
import ImageSliderModal from './components/ImageSliderModal'
import PercentageCalculation from './components/PercentageCalculation'
import Nosto from './components/Nosto'
import YouTube from './components/YouTube'
import Vimeo from './components/Vimeo'

// import VinPrompt from './components/VinPrompt'
import ExpectedDelivery from './components/ExpectedDelivery'
import ProductSharing from './components/ProductSharing'
// import ProductAccordion from './components/ProductAccordion'
import ProductTabs from './components/ProductTabs'
import SearchForm from './components/SearchForm'
import QuantitySelector from './components/QuantitySelector'
import QuickView from './components/QuickView'
import KlevuLanding from './components/KlevuLanding'
import DeliveryDates from './components/DeliveryDates'
import CartTable from './components/CartTable'
import ReadMore from './components/ReadMore'
// import ProductSwatches from './components/NOTUSEDProductSwatches'
import ProductForm from './components/ProductForm'
import ProductInstallation from './components/ProductInstallation'
import ServicePlansForm from './components/ServicePlansForm'
import ServicePlansDealerForm from './components/ServicePlansFormDealer'

// import VinLookup from './components/VinLookup'
import ContentExpansion from './components/ContentExpansion'
// import CurrentCar from './components/CurrentCar'
import ExternalLinkProduct from './components/ExternalLinkPopup'
import BenefitIcons from './components/BenefitIcons'
// import ModelLanding from './components/ModelLanding'
// import WcView from './components/wheel-config/WcView'
// import WcColours from './components/wheel-config/WcColours'
// import WcSlider from './components/wheel-config/WcSlider'
// import WcTyres from './components/wheel-config/WcTyres'
import ProductKit from './components/ProductKit'
import DataLayer from './components/DataLayer'
import CookiePro from './components/CookiePro'
import FreeGift from './components/FreeGift'
// import CheckCompatibility from './components/CheckCompatibility'
import OverlayScrollbars from './components/OverlayScrollbars'
import VehicleState from './components/garage/VehicleState'
import CompatibilityChecker from './components/garage/CompatibilityChecker'
import ScrollTo from './components/ScrollTo'
import CompatibilityCheck from './components/garage/CompatibilityCheck'
import HelpTrigger from './components/HelpTrigger'

/**
 * Pages.
 */
import Addresses from './pages/Addresses'
import Login from './pages/Login'
import Cart from './pages/Cart'
import PageSantander from './pages/PageSantander'
import Payment from './pages/Payment'
/**
 * Sections
 */
import NewsletterModal from './sections/NewsletterModal'
import SiteHeader from './sections/SiteHeader'
import SiteFooter from './sections/SiteFooter'
import ServiceCards from './sections/ServiceCards'
import MenuDrawer from './sections/MenuDrawer'
// import ServicePlans from './sections/ServicePlans'
import CartDrawer from './sections/CartDrawer'
import DealerLocator from './sections/DealerLocator'

const components = {
    // 'select': Select,
    'slick': Slick,
    // 'preloader': Preload,
    'product-kit': ProductKit,
    'overlay-scrollbars': OverlayScrollbars,
    'vehicle-state': VehicleState,
    'compatibility-checker': CompatibilityChecker,
    'compatibility-check': CompatibilityCheck,
    'searchbar': SearchBar,
    'collection-panel': CollectionPanel,
    'product-installation': ProductInstallation,
    // 'check-compatibility': CheckCompatibility,
    'cookie-pro': CookiePro,
    'notification': Notification,
    'change-class': ChangeClass,
    'carousel': Carousel,
    'masonry': Masonry,
    'accordion': Accordion,
    'toggle': Toggle,
    'vehicle-carousel': VehicleCarousel,
    'sitenav': SiteNav,
    'country': CountrySelector,
    'modal': Modal,
    'klevu-search': KlevuSearch,
    'image-slider-modal': ImageSliderModal,
    'percentage-calculation': PercentageCalculation,
    // 'vin-prompt': VinPrompt,
    'expected-delivery': ExpectedDelivery,
    'product-sharing': ProductSharing,
    'product-gallery': ProductGallery,
    'readmore': ReadMore,
    // 'product-accordion': ProductAccordion,
    'search-form': SearchForm,
    'quantity-selector': QuantitySelector,
    'quick-view': QuickView,
    'klevu-landing': KlevuLanding,
    'delivery-dates': DeliveryDates,
    'cart-table': CartTable,
    'product-form': ProductForm,
    // 'vin-lookup': VinLookup,
    'service-plans-form': ServicePlansForm,
    'service-plans-dealer-form': ServicePlansDealerForm,
    // 'current-car': CurrentCar,
    'external-link-popup': ExternalLinkProduct,
    'content-expansion': ContentExpansion,
    'benefit-icons': BenefitIcons,
    // 'model-landing': ModelLanding,
    // 'wc-view': WcView,
    // 'wc-tyres': WcTyres,
    // 'wc-colours': WcColours,
    // 'wc-slider': WcSlider,
    'data-layer': DataLayer,
    'free-gift': FreeGift,
    'payment': Payment,
    'product-tabs': ProductTabs,
    'scroll-to': ScrollTo,
    'nosto': Nosto,
    'vimeo': Vimeo,
    'youtube': YouTube,
    'help-trigger': HelpTrigger
}

const pages = {
    'customers/addresses': Addresses,
    'customers/login': Login,
    'cart': Cart,
    'page.santander': PageSantander
}

/**
 * Global theme section imports.
 */
const sections = {
    'newsletter-modal': NewsletterModal,
    'site-header': SiteHeader,
    'site-footer': SiteFooter,
    'service-cards': ServiceCards,
    'menu-drawer': MenuDrawer,
    // 'service-plans': ServicePlans,
    'cart-drawer': CartDrawer,
    'dealer-locator': DealerLocator
}

if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach
}

/**
* Load Shopify Sections
* Load helpers
*/
document.addEventListener('DOMContentLoaded', () => {
    load('*')
    AjaxCart().init()
    Redirects().init()
})

/**
* Global Frame utils
*/
window.Frame = window.Frame || {}
window.Frame.EventBus = EventBus()
window.Frame.CurrentCarCookie = CurrentCarCookie()

class Theme {
    constructor () {
        this._components = []
        this._componentsById = {}
        this._sections = []
        this._sectionsByType = {}
    }

    registerComponents (container = document) {
        for (let key in components) {
            var ComponentConstructor = components[key]
            var elements = container.querySelectorAll(`.js-component__${key}, [data-${key}]`)
            for (let elem of elements) {
                var instance = new ComponentConstructor(this, elem)
                this._components.push(instance)
                var id = elem.dataset.componentId
                if (id) {
                    this._componentsById[id] = instance
                }
                instance.onInit()
            }
        }
        window.ThemeComponents = this._components
        window.ThemeComponentsId = this._componentsById
        window.__Theme = this
    }

    registerPages () {
        var context = pageContext.getTemplate()
        for (let page in pages) {
            if (page === context) {
                var instance = new pages[page](this)
                instance.onInit()
            }
        }
    }

    registerSections () {
        for (let section in sections) {
            const sectionElements = document.querySelectorAll(`[data-section-type="${section}"]`)
            for (let sectionElement of sectionElements) {
                const sectionType = sectionElement.getAttribute('data-section-type')
                if (section === sectionType) {
                    var instance = new sections[section](this)
                    instance.onInit(this, sectionElement)
                    this._sections.push(instance)
                    this._sectionsByType[sectionType] = instance
                }
            }
        }
    }

    getComponents () {
        return this._components
    }

    getComponentsById (id) {
        return this._componentsById[id]
    }

    getComponentsByType (componentConst, includeSubclasses = true) {
        var r = []
        for (let c of this._components) {
            if (includeSubclasses && c instanceof componentConst) {
                r.push(c)
            } else if (c.constructor === componentConst) {
                r.push(c)
            }
        }
        return r
    }

    getSections () {
        return this._sections
    }

    getSectionsByType (type) {
        return this._sectionsByType[type]
    }
}

export default Theme



// WEBPACK FOOTER //
// ./src/resources/scripts/Theme.js